import { collection, doc, getDoc, updateDoc } from 'firebase/firestore/lite';
import { firestore } from '../utils/firebase';
import LegalDocumentConverter from './legalDocumentConverter';
import LegalDocumentData from '../types/legalDocumentData';

export default class LegalDocumentApi {
  private static readonly collectionReference = collection(firestore, 'legalDocuments').withConverter(
    LegalDocumentConverter
  );

  static async getLegalDocument(id: string): Promise<LegalDocumentData> {
    const docRef = doc(this.collectionReference, id);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
      throw new Error(`Legal document with id ${id} does not exist`);
    }
    return docSnap.data();
  }

  static async updateLegalDocument(id: string, updatedLegalDocument: LegalDocumentData) {
    const docRef = doc(this.collectionReference, id);
    await updateDoc(docRef, updatedLegalDocument);
  }
}
